import { createSelector } from '@reduxjs/toolkit'

export const themeProviderSelector = state => state.themeProviderReducer

export const getThemeList = () =>
  createSelector(themeProviderSelector, theme => theme.list)
export const getActive = () =>
  createSelector(themeProviderSelector, theme => theme.active)
